module.exports = __webpack_public_path__ + "img/0Q3A5746_L_WoodMatted.6e08b113.jpg";